import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { FaToggleOff, FaToggleOn } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../common/languageSelector';
import FormCard from '../common/formCard';
import { FaPlus } from 'react-icons/fa6';
import { DisableIncidentCategoryService, PatchIncidentCategoryService, PostIncidentCategoryService } from '../../Services/incidentCategoryService';
import MessagePopUp from '../common/messagePopUp';
import { DisableCustomQuestionService, PatchCustomQuestionService, PostCustomQuestionService } from '../../Services/customQuestionsService';

function CustomizationManagePopUp({ company, show, handleClose, handleReloadData, title, data, buttonSendText, question = false }) {

    const [availableLanguages, setAvailableLanguages] = useState(['es', 'ca', 'eu', 'en', 'it']);
    const [selectedLanguages, setSelectedLanguages] = useState({});
    const [fieldErrors, setFieldErrors] = useState({});
    const [langs, setLangs] = useState({});
    const [languageCards, setLanguageCards] = useState([]);
    const [filteredAvailableLanguages, setFilteredAvailableLanguages] = useState(availableLanguages);
    const [showDisableLang, setShowDisableLang] = useState(false);
    const [popupMessage, setPopupMessage] = useState({});
    const [loading, setLoading] = useState(false);
    const [t] = useTranslation("companies");

    const initialFormData = {
        // Agregar condicionalmente la propiedad title o name
        ...(question ? { title: [] } : { name: [] }),
        company: company,
        language: [],
        default: false
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (data && data.length > 0) {
            // Extraer categoryGroup de los datos y los mismos si están disponibles

            if (question) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    questionGroup: data[0].questionGroup,
                    title: data.map(item => item.title),
                    language: data.map(item => item.language),
                    enabled: data.map(item => item.enabled),
                    customQuestion: data.map(item => item.customQuestion)
                }));
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    categoryGroup: data[0].categoryGroup,
                    name: data.map(item => item.name),
                    language: data.map(item => item.language),
                    enabled: data.map(item => item.enabled),
                    incidentCategory: data.map(item => item.incidentCategory)
                }));
            }

            // Preparar los estados para las tarjetas de idioma
            const newLangs = {};
            const newSelectedLanguages = {};
            data.forEach((item, index) => {
                newLangs[`lang${index}`] = item.language;
                newSelectedLanguages[item.language] = true;
            });

            // Actualizar los estados
            setLangs(newLangs);
            setSelectedLanguages(newSelectedLanguages);
            setLanguageCards(data.map((element, index) => index));
        } else {
            // Si no hay datos, inicializar una tarjeta
            setLanguageCards([0]);
        }
    }, [data]);




    const validateField = async (index, value) => {
        let isError = false;
        let errorMessage = null;

        switch (index) {
            case 'lang0':
                if (value === "") {
                    isError = true;
                    errorMessage = isError ? `${t("customizationManagePopUp.error")}` : null;
                } else if (value.length > (question ? 100 : 50)) {
                    isError = true;
                    errorMessage = question ? t("customizationManagePopUp.errorLength100") : t("customizationManagePopUp.errorLength50");
                }
                break;

            case 'lang1':
                if (value === "") {
                    isError = true;
                    errorMessage = isError ? `${t("customizationManagePopUp.error")}` : null;
                } else if (value.length > (question ? 100 : 50)) {
                    isError = true;
                    errorMessage = question ? t("customizationManagePopUp.errorLength100") : t("customizationManagePopUp.errorLength50");
                }
                break;

            case 'lang2':
                if (value === "") {
                    isError = true;
                    errorMessage = isError ? `${t("customizationManagePopUp.error")}` : null;
                } else if (value.length > (question ? 100 : 50)) {
                    isError = true;
                    errorMessage = question ? t("customizationManagePopUp.errorLength100") : t("customizationManagePopUp.errorLength50");
                }
                break;

            case 'lang3':
                if (value === "") {
                    isError = true;
                    errorMessage = isError ? `${t("customizationManagePopUp.error")}` : null;
                } else if (value.length > (question ? 100 : 50)) {
                    isError = true;
                    errorMessage = question ? t("customizationManagePopUp.errorLength100") : t("customizationManagePopUp.errorLength50");
                }
                break;

            case 'lang4':
                if (value === "") {
                    isError = true;
                    errorMessage = isError ? `${t("customizationManagePopUp.error")}` : null;
                } else if (value.length > (question ? 100 : 50)) {
                    isError = true;
                    errorMessage = question ? t("customizationManagePopUp.errorLength100") : t("customizationManagePopUp.errorLength50");
                }
                break;

            default:
                break;
        }
        setFieldErrors((prevFieldErrors) => {
            const newErrors = { ...prevFieldErrors, [index]: isError };
            newErrors[`${index}Message`] = errorMessage;
            return newErrors;
        });
        return !isError
    };

    const validateAllFields = async () => {
        let returnValue = true;

        if (languageCards.length < 1) {
            returnValue = await validateField('lang0', '');
        } else {
            for (const value of languageCards) {
                const fieldId = `lang${value}`;

                let formDataValue;

                if (question) {
                    formDataValue = formData.title[value];

                } else {
                    formDataValue = formData.name[value];

                }


                const result = await validateField(fieldId, formDataValue || '');
                if (!result) {
                    returnValue = false;
                    break;
                }
            }
        }

        return returnValue;
    };


    const handleFieldChange = (index, value) => {
        setFormData((prevFormData) => {
            // Actualizar los valores de formData basado en el index y el value
            let updatedFormData = { ...prevFormData };


            if (index.startsWith('lang')) {
                // Actualizar el array 'name' o tile
                const langIndex = parseInt(index.substring(4));


                if (question) {
                    let updatedTitles = [...prevFormData.title];
                    updatedTitles[langIndex] = value;
                    updatedFormData.title = updatedTitles;
                } else {
                    let updatedNames = [...prevFormData.name];
                    updatedNames[langIndex] = value;
                    updatedFormData.name = updatedNames;
                }

            } else {
                // Para otros campos 
                updatedFormData[index] = value;
            }

            // Actualizar el aeeay 'language' basado en selectedLanguages
            updatedFormData.language = Object.keys(selectedLanguages);

            // Validar el campo cuando se actualiza
            validateField(index, value);

            return updatedFormData;
        });
    };


    const handleSetLanguage = (value, index) => {
        // Guardar el idioma anterior antes de actualizar
        const previousLanguage = langs[index];

        // Actualizar el idioma seleccionado para la tarjeta actual
        setLangs(prevLangs => ({
            ...prevLangs,
            [index]: value
        }));

        // Actualizar los idiomas seleccionados
        setSelectedLanguages(prevSelected => {
            const updatedSelected = { ...prevSelected };

            // Si había un idioma seleccionado anteriormente, eliminarlo de selectedLanguages
            if (previousLanguage) {
                delete updatedSelected[previousLanguage];
            }

            // Añadir el nuevo idioma seleccionado
            updatedSelected[value] = true;

            return updatedSelected;
        });
    };




    const handleAddLangClick = () => {
        setLanguageCards(prevCards => [...prevCards, prevCards.length]);
    };

    const handleToggleEnabled = async (data) => {
        if (data.enabled) {
            let messageTitle = `${t("customizationManagePopUp.disableTitle")}`;
            let messageBody = question ? t("customizationManagePopUp.disableText2") : t("customizationManagePopUp.disableText");
            setPopupMessage({
                title: messageTitle,
                body: messageBody,
                data: data
            });
            setShowDisableLang(true)
        }

        else {
            if (question) {
                const response = await DisableCustomQuestionService(data, data.customQuestion);

            } else {
                const response = await DisableIncidentCategoryService(data, data.incidentCategory);

            }
            data.enabled = !data.enabled;
            handleReloadData();
        }
    }

    const handleDisableConfirmClick = async (data) => {
        if (question) {
            const response = await DisableCustomQuestionService(data, data.customQuestion);

        } else {
            const response = await DisableIncidentCategoryService(data, data.incidentCategory);

        }
        data.enabled = !data.enabled;
        setShowDisableLang(false)

    };


    const handleSubmit = async () => {
        let validFields = await validateAllFields();
        if (validFields) {
            let response;
            setLoading(true)
            if (question) {
                if (data) {
                    for (let i = 0; i < formData.language.length; i++) {
                        let individualFormData;
                        if (formData.customQuestion && formData.customQuestion[i]) {
                            // Actualizar un elemento existente
                            individualFormData = {
                                title: formData.title[i],
                                questionGroup: formData.questionGroup,
                                enabled: formData.enabled[i],
                                language: formData.language[i],
                                company: formData.company
                            };
                            response = await PatchCustomQuestionService(formData.customQuestion[i], individualFormData);
                        } else {
                            // Crear un nuevo elemento con solo los valores de name y language en la posición i
                            individualFormData = {
                                title: [formData.title[i]],
                                company: formData.company,
                                language: [formData.language[i]],
                                questionGroup: formData.questionGroup
                            };
                            response = await PostCustomQuestionService(individualFormData);
                        }

                    }

                } else {
                    response = await PostCustomQuestionService(formData);
                }
            } else {
                if (data) {
                    for (let i = 0; i < formData.language.length; i++) {
                        let individualFormData;

                        if (formData.incidentCategory && formData.incidentCategory[i]) {
                            // Actualizar un elemento existente
                            individualFormData = {
                                name: formData.name[i],
                                categoryGroup: formData.categoryGroup,
                                enabled: formData.enabled[i],
                                language: formData.language[i],
                                company: formData.company
                            };
                            response = await PatchIncidentCategoryService(formData.incidentCategory[i], individualFormData);
                        } else {
                            // Crear un nuevo elemento con solo los valores de name y language en la posición i
                            individualFormData = {
                                name: [formData.name[i]],
                                company: formData.company,
                                language: [formData.language[i]],
                                categoryGroup: formData.categoryGroup
                            };
                            response = await PostIncidentCategoryService(individualFormData);
                        }

                    }

                } else {
                    response = await PostIncidentCategoryService(formData);
                }

            }

            setLoading(false)
            handleClose();
            handleReloadData();
        }
    };




    useEffect(() => {
        const newFilteredLanguages = availableLanguages.filter(lang => !selectedLanguages[lang]);
        setFilteredAvailableLanguages(newFilteredLanguages);
    }, [availableLanguages, selectedLanguages]);


    const renderTooltipEnable = (isEnabled) => (props) =>
    (
        <Tooltip id="button-tooltip" {...props}>
            {isEnabled ? `${t("customizationManagePopUp.disable")}` : `${t("customizationManagePopUp.enable")}`}
        </Tooltip>
    );


    return (<>
        <MessagePopUp
            show={showDisableLang}
            handleClose={() => setShowDisableLang(false)}
            title={popupMessage.title}
            textBody={popupMessage.body}
            buttonText={t("customizationManagePopUp.confirmButton")}
            cancelButtonText={t("customizationManagePopUp.cancelButton")}
            onClickCancelButton={() => setShowDisableLang(false)}
            onClickButton={() => handleDisableConfirmClick(popupMessage.data)}
        />

        <Modal show={show} onHide={handleClose} backdrop="static">
            <Modal.Body className=" width-75-vw">
                <Container>
                    <Card className="mx-auto p-3 rounded-border-px custom-shadow">
                        <Card.Body className="d-flex flex-column align-items-center">
                            <p className=" text-center modal-title mt-2 mb-3">
                                <span className='text-uppercase'>{title}</span>
                            </p>
                            <div className="text-center mt-auto w-100">
                                <Button
                                    variant="none"
                                    className="modal-close-button"
                                    onClick={handleClose}
                                >
                                    <FaTimes className="mb-1" />
                                </Button>


                                {
                                    languageCards.map((index) => (
                                        <div key={index} className='customization-popup-content-container'>
                                            <div className='mt-4'>
                                                <LanguageSelector
                                                    grayBackground={true}
                                                    availableLanguages={
                                                        langs[`lang${index}`] // Si ya se seleccionó un idioma para esta tarjeta
                                                            ? [langs[`lang${index}`], ...filteredAvailableLanguages.filter(lang => lang !== langs[`lang${index}`])]
                                                            : filteredAvailableLanguages
                                                    }
                                                    defaultLanguage={
                                                        langs[`lang${index}`] // Si ya se seleccionó un idioma para esta tarjeta
                                                            ? langs[`lang${index}`]
                                                            : filteredAvailableLanguages[0]
                                                    }
                                                    disabled={data[index] && data[index].language === langs[`lang${index}`]}
                                                    onChange={(value) => handleSetLanguage(value.value, `lang${index}`)}
                                                />
                                            </div>
                                            <Col md={10}>
                                                <FormCard
                                                    type="textarea"
                                                    text={data && data[index] ? data[index].name ? data[index].name : data[index].title : null}
                                                    error={fieldErrors[`lang${index}`]}
                                                    errorMessage={fieldErrors[`lang${index}Message`]}
                                                    title={`${t("customizationManagePopUp.formCardTitle")} ${question ? t("customizationManagePopUp.formCardTitleQuestion") : t("customizationManagePopUp.formCardTitleCategory")} ${t("customizationManagePopUp.formCardTitle2")}`}
                                                    onChange={(e) =>
                                                        handleFieldChange(`lang${index}`, e.target.value)
                                                    }
                                                />
                                            </Col>
                                            {data &&
                                                <div className='mt-4'>

                                                    {data[index] && data[index].enabled ? (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 250 }}
                                                            overlay={renderTooltipEnable(data[index].enabled)}
                                                        >
                                                            <Button

                                                                onClick={() => handleToggleEnabled(data[index])}
                                                                className="custom-shadow-bold enable-button"
                                                            >
                                                                <FaToggleOff className="mb-1" size={20} />
                                                            </Button>

                                                        </OverlayTrigger>
                                                    ) : (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 250 }}
                                                            overlay={renderTooltipEnable(data[index] ? data[index].enabled : true)}
                                                        >
                                                            {/* Mostrar el botón si se edita pero como deshabilitado */}
                                                            <Button
                                                                onClick={() => handleToggleEnabled(data[index])}
                                                                className="custom-shadow-bold disable-button"
                                                                disabled={!data[index]}
                                                            >
                                                                <FaToggleOn className="mb-1" size={20} />
                                                            </Button>

                                                        </OverlayTrigger>
                                                    )}





                                                </div>


                                            }
                                        </div>
                                    ))
                                }

                                {
                                    languageCards.length < 4 && (
                                        <div className='mt-4 mx-auto customization-popup-add-button custom-shadow-bold' onClick={handleAddLangClick}>
                                            <FaPlus size={15} />
                                            <span className='font-bold'>{t("customizationManagePopUp.add")}</span>
                                        </div>
                                    )
                                }



                                <div className='d-flex'>
                                    <Button
                                        type="none"
                                        className=" mx-auto mt-5 custom-button-secondary text-uppercase"
                                        onClick={handleClose}
                                    >
                                        {t("customizationManagePopUp.cancelButton")}
                                    </Button>
                                    <Button
                                        type="submit"
                                        className=" mx-auto mt-5 custom-button-primary custom-bg-primary text-uppercase"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    >
                                        {loading ?
                                            <>
                                                <Spinner animation="border" className="spinner" />
                                                <span className="common-card-card-text">{buttonSendText}</span>

                                            </>
                                            :
                                            <>
                                                {buttonSendText}

                                            </>
                                        }
                                        {/* {buttonSendText} */}
                                    </Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
            </Modal.Body>
        </Modal>
    </>
    );
}

export default CustomizationManagePopUp;
